const DAYS_SHORT = ['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo']

const ChargerList = ({ chargers, onToggleAvailable, onViewOnMap }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {chargers.map(charger => (
        <div key={charger.id} style={{
          background: 'white', borderRadius: 16, padding: 16,
          border: '1px solid var(--cream-dark)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
        }}>

          <div style={{
            display: 'flex', justifyContent: 'space-between',
            alignItems: 'flex-start', marginBottom: 10
          }}>
            <div style={{ flex: 1, marginRight: 10 }}>
              <div style={{
                fontFamily: 'Fraunces, serif', fontSize: 16,
                fontWeight: 900, color: 'var(--ink)', marginBottom: 3
              }}>
                {charger.name}
              </div>
              <div style={{ color: 'var(--ink-muted)', fontSize: 12 }}>
                📍 {charger.address}, {charger.city}
              </div>
            </div>
            <button
              onClick={() => onToggleAvailable(charger)}
              style={{
                background: charger.is_available ? 'var(--green-pale)' : '#f3f4f6',
                border: `1.5px solid ${charger.is_available ? 'var(--green)' : 'var(--cream-dark)'}`,
                borderRadius: 20, padding: '5px 12px',
                color: charger.is_available ? 'var(--green)' : 'var(--ink-muted)',
                fontWeight: 700, cursor: 'pointer', fontSize: 11,
                fontFamily: 'DM Sans, sans-serif', flexShrink: 0
              }}>
              {charger.is_available ? '● Online' : '○ Offline'}
            </button>
          </div>

          <div style={{ display: 'flex', gap: 7, marginBottom: 10, flexWrap: 'wrap' }}>
            {[charger.connector_type, `${charger.speed_kw}kW`, `€${charger.price_per_kwh}/kWh`].map((tag, i) => (
              <span key={i} style={{
                background: 'var(--cream)', border: '1px solid var(--cream-dark)',
                borderRadius: 20, padding: '3px 10px', fontSize: 11,
                color: 'var(--green)', fontWeight: 700
              }}>
                {tag}
              </span>
            ))}
          </div>

          {charger.charger_availability && charger.charger_availability.length > 0 && (
            <div style={{ marginBottom: 10 }}>
              <div style={{
                fontSize: 10, fontWeight: 700, color: 'var(--ink-muted)',
                letterSpacing: 0.5, textTransform: 'uppercase', marginBottom: 6
              }}>
                Beschikbaarheid
              </div>
              <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                {charger.charger_availability.map((slot, i) => (
                  <div key={i} style={{
                    background: 'var(--green-pale)', border: '1px solid var(--green-mid)',
                    borderRadius: 8, padding: '3px 8px', fontSize: 10,
                    color: 'var(--green)', fontWeight: 600
                  }}>
                    {DAYS_SHORT[slot.day_of_week]} {slot.start_time.slice(0, 5)}–{slot.end_time.slice(0, 5)}
                  </div>
                ))}
              </div>
            </div>
          )}

          <button
            onClick={() => onViewOnMap(charger)}
            style={{
              width: '100%', background: 'var(--green-pale)',
              border: '1px solid var(--green-mid)', borderRadius: 10,
              padding: '8px 14px', color: 'var(--green)', fontWeight: 700,
              cursor: 'pointer', fontSize: 12, fontFamily: 'DM Sans, sans-serif'
            }}>
            🗺️ Bekijk op kaart
          </button>
        </div>
      ))}
    </div>
  )
}

export default ChargerList
